'use client'
import React, {useEffect, useState} from 'react'
import {Popover, PopoverContent, PopoverTrigger, Spinner} from '@heroui/react'
import {usePathname} from 'next/navigation'
import {useSession} from 'next-auth/react'

import NavCustomerPopover from '@/components/NavigationBar/NavCustomerPopover'
import {Body5} from '@/components/UI/Typography'

import Box from '../UI/Box/Box'
import ButtonWrapper from '../UI/ButtonWrapper/ButtonWrapper'
import Icon from '../UI/Icon/Icon'
import {useDebouncedCallback} from '../../src/shared/utils/useDebounce'

import {CustomerSummary} from '@/src/services/UserService/types'

const NavCustomer = ({
  customerSummary,
}: {
  customerSummary: CustomerSummary | null
}) => {
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false)
  const {data: session} = useSession()
  const pathname = usePathname()

  const onProfileMenuHover = useDebouncedCallback((value: boolean) => {
    setIsAccountMenuOpen(value)
  }, 300)

  useEffect(() => {
    setIsAccountMenuOpen(false)
  }, [pathname])

  return (
    <Box
      aria-label="navbar-link-for-my-baby"
      onMouseEnter={() => {
        onProfileMenuHover(true)
      }}
      onMouseLeave={() => {
        onProfileMenuHover(false)
      }}>
      <Popover isOpen={isAccountMenuOpen}>
        <PopoverTrigger onOpenChange={onProfileMenuHover}>
          <ButtonWrapper>
            <Box
              className="items-center gap-2"
              onPress={() => {
                onProfileMenuHover(true)
                setIsAccountMenuOpen(true)
              }}>
              <Icon name="profileOutline" className="fill-primary" size={20} />
              <Body5 className="hidden md:block">Hesabım</Body5>
            </Box>
          </ButtonWrapper>
        </PopoverTrigger>
        <PopoverContent className="min-w-[180px]">
          {!customerSummary && session?.userId ? (
            <Box className="h-16">
              <Spinner size="sm" />
            </Box>
          ) : (
            <NavCustomerPopover customerSummary={customerSummary} />
          )}
        </PopoverContent>
      </Popover>
    </Box>
  )
}

export default NavCustomer
